import { render } from "./ASServiciileNoastre.vue?vue&type=template&id=6a0cc1fd"
import script from "./ASServiciileNoastre.vue?vue&type=script&lang=js"
export * from "./ASServiciileNoastre.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__